export default {
    name: 'Tiếng Việt',
    headers:{
        dashBoard:'Tổng quan',
        market:'Thị trường',
        liquidation:'Thanh lý',
        larix:'LARIX',
        Positions:'Vị trí',
        stake:'Cổ phần',
        dao:'DAO',
        connect:'Kết nối',
        About:'Tìm hiểu',
        reward:'Phần thưởng',
        launchpad:'Launchpad',
        main:'Main Pool'
    },
    reward:{
        larixBalance:'LARIX Hiện có',
        larixRewards:'Phần thưởng LARIX',
        mSOLReward:'mSOL Thưởng',
        insufficientUsdcBalance:'Insufficient USDC balance',
        stake:'Cổ phần',
        stakeForLP:'Cổ phần để tạo LP',
        earn2x:'Tiền đặt cọc để kiếm {x} lần Phần thưởng LARIX',
        claimDirectly:'yêu cầu ',
        myStaking: 'Kỳ tích của tôi',
        seeDetails: 'Xem chi tiết',
        youWillLose1: 'Yêu cầu ngay bây giờ Bạn sẽ mất Cơ hội',
        youWillLose2: 'kiếm thêm {x} Phần thưởng LARIX',
        reward:'Phần thưởng',
        walletBalance:'* Số dư trên Wallet :',
        maximumReceive:'MAX có thể yêu cầu bồi thường {x} LARIX',
        expiredReward:'Phần thưởng sau thời gian khóa',
        days:'ngày',
        currentRewards:'Phần thưởng hiện tại',
        stakeTime:'Thời gian khóa máy',
        claimLARIX:'Claim LARIX',
        needUSDC:'Estimated USDC ≈',
        chooseToReceive:'Choose to receive',
        main:"Main",
    },
    wallet:{
        reward:'Phần thưởng',
        connect:'Kết nối',
        faucet:'Faucet',
        connectToAWallet:'Kết nối ví',
        yourWallet:'Ví của bạn',
        disconnect:'Ngắt kết nối',
        connected:'Đã kết nối',
        harvest:'Yêu cầu ngay',
        walletBalance: 'Số dư trên Wallet',
        unclaimedBalance: 'Phần thưởng có thể yêu cầu',
        price: 'Giá LARIX',
        nothingToClaim: 'Đã nhận hết',
        subAccount :'My position',
        recentTransactions : 'Giao dịch gần đây',
        wallet : 'Ví'
    },
    footer:{
        doc:'Tài liệu'
    },
    home:{
        totalSupply:'Tổng cung',
        totalBorrow:'Tổng vay',
        totalMined:'Tổng lượng khai thác',
        larixPrice:'Giá Larix',
        supplyMarket:'Thị trường cung',
        borrowMarket:'Thị trường vay',
        myBill:'Hóa đơn của tôi',
        asset:'Tài sản',
        collateral:'Thế chấp',
        allMarket:'tất cả thị trường',
        supplyAPY:'Lãi suất Cung',
        wallet:'Ví',
        borrowAPY:"Lãi suất vay",
        liquidity:"Thanh khoản",
        operation:"Quy trình hoạt động",
        borrowBalance:"Số lượng Vay",
        supplyBalance:"Số lượng Cung",
        withdraw:"Rút",
        repay:"Trả",
        supply:"Cung cấp",
        borrow:"Vay",
        loading:"Đang tải",
        connectToAWallet:'Kết nối ví',
        liquidityMining:'khai thác thanh khoản',
        totalAPR:'tổng APR',
        more:'tất cả các',
        pool:'Pool',
        raydiumLP:'Raydium LP',
        unsettledAssets:'Chưa quyết toán tài sản',
        handleTip:'Transaction undone, please click here to process >',
        singleAsset:'Tài sản đơn lẻ',
        myPosition:'Vị trí của tôi',
        tip:'Tip',
        noBorrowFee:'Không có phí vay',
    },
    supplyAndBorrow:{
        borrowLimit:"Hạn mức Vay",
        netAPY:"APR ròng",
        borrowBalance:"Dư nợ",
        supplyBalance:"Số lượng Cung",
        netValue:'Giá trị ròng',
        borrowRatio:'Tỷ lệ đi vay',
    },
    supplyDialog: {
        supply: "Cung",
        withDraw: "Rút",
        wallet: "Ví",
        balance: "Số dư",
        walletBalance: "ví",
        liquidity: "Thanh khoản",
        max: "MAX",
        limit85: "85% hạn mức",
        supplyApy: "APR Cung",
        supplyBalance: "Số lượng Cung",
        borrowLimit: "Hạn mức Vay",
        supplyRate: "Tỷ suất Cung",
        withdrawRate: "Tỷ suất Rút",
        invalidNumber:"Số không hợp lệ",
        insufficientLiquidity:"Thanh khoản không đủ",
        stillWithdraw:"Rút bằng mọi cách",
        borrowLimitUsedPercent:"Tỷ lệ Sử dụng Hạn mức Vay",
        collateralFactor:"Yếu tố Thế chấp",
        insufficientFunds:"Số dư không đủ",
        solBalanceIsLow:'SOL Số dư thấp',
        cancel:'Hủy',
        interestRate: "Lãi suất",
        miningAPY: "APR Khai thác",
        supplyMaxLimit100M:"Giới hạn Cung cao nhất là {x}",
        currentSupply:"Current supply amount is",
        reachLpLimit:"Reach LP deposit Limit",
        reachLimit:"Reach deposit Limit",
        baseReward:'Phần thưởng cơ bản',
        boostedAPR:'APR LARIX được tăng cường',
        APR:'APR',
        supplyMaxAPR:'Max APR',
        baseAPR:'Base APR',
        baseLARIXRewards:'Base LARIX rewards',
        borrowingMinAPR:'Min APR',
    },
    borrowDialog: {
        borrow: "Vay",
        repay: "Trả",
        wallet: "Ví",
        balance: "Số dư",
        walletBalance: "ví",
        liquidity: "thanh khoản",
        borrowMax: "MAX",
        max:'MAX',
        borrowApy: "APR Vay",
        borrowBalance: "Số lượng Vay",
        borrowLimit: "Hạn mức Vay",
        borrowRate: "Tỷ suất Vay",
        repayRate: "Tỷ suất trả",
        borrowMaxInTokenUnit:"Vay hạn mức Cao nhất",
        borrowLimitUsedPercent:"Tỷ lệ Sử dụng Hạn mức Vay",
        collateralFactor:"Yếu tố Thế chấp",
        invalidNumber:"Số không hợp lệ",
        insufficientLiquidity:"Thanh khoản không đủ",
        stillBorrow:"Vay bằng mọi cách",
        noBalanceToRepay:"Không còn nợ phải trả",
        insufficientFunds:"Số dư không đủ",
        cancel:'Hủy',
        interestRate: "Lãi suất",
        miningAPY: "APR khai thác",
        reachPositionLimit:'Mỗi tài khoản được giới hạn tổng cộng 5 loại tài sản thế chấp và vay.',
    },
    market:{
        supply:"Cung",
        borrow:"Vay",
        top3Markets:"Top 3 Thị trường",
        asset:"Tài sản",
        totalSupply:"Tổng Cung",
        supplyAPY:"APR Cung",
        totalBorrow:"Tổng Vay",
        borrowAPY:"APR Vay",
        details:"Chi tiết",
        supplyBorrow:'Tổng giá trị Giao dịch',
        loading:"Đang tải",
        connectToAWallet:'Kết nối ví',
        totalSupplyApy:"Tổng Cung/APR",
        totalBorrowApy:"Tổng Vay/APR",
        depositLimit:"Hạn mức Gửi",
        supplyIR:'Lãi suất Cung ứng',
        borrowIR:'Lãi suất Vay',
        supplyDistributionAPR:'APR Phân bổ cho Cung ứng',
        borrowDistributionAPR:'APR Phân bổ cho Vay mượn',
        supplyIRHelpContext:'APR Cung = Lãi suất Cung + APR Khai thác',
        borrowIRHelpContext:'APR Vay = Lãi suất Vay - APR Khai thác',
        stake:'Stake',
        swap:'Swap',
    },
    marketId:{
        market:"Thị trường",
        supply:"Cung",
        borrow:"Vay",
        netRate:"APR Ròng",
        supplyAPY:"APR Cung",
        distributionSupplyAPY:"Sự phân bổ APR",
        distributionBorrowAPY:"Sự phân bổ APR",
        totalSupply:"Tổng Cung",
        borrowAPY:"APR Vay",
        totalBorrow:"Tổng Vay",
        interestRateModel:"Mô hình Lãi suất",
        marketDetails:"Chi tiết Thị trường",
        Price:"Giá",
        marketLiquidity:"Thanh khoản Thị trường",
        collateralFactor:"Yếu tố Thế chấp",
        exchangeRate:"Lãi suất Sàn giao dịch",
        supplyMiningAPR:"APR Khai thác Cung ứng",
        borrowMiningAPR:"APR Khai thác Vay mượn",
        utilization:"Sử dụng",
        supplyChartAPY:"APR Cung",
        borrowChartAPY:"APR Vay",
        mndeAPR:"APR"
    },
    larix:{
        amountinCirculation:"Số lượng Lưu hành",
        circulatingMarketCap:"Vốn hóa thị trường",
        totalSupply:"Tổng Lượng",
        lARIXDistribution:"Sự phân bổ LARIX",
        market:"Thị trường",
        perDay:"Khai thác hàng ngày",
        supplyMiningAPR:"APR Khai thác Cung",
        borrowMiningAPR:"APR Khai thác Vay",
        dailyDistribution:"Sự phân bổ Hàng ngày",
        other:"Khác",
        distribution:"Sự phân bổ",
        larixPrice:'Giá Larix',
    },
    About:{
        aboutLarix:"Về Larix",
        aboutLarixContext:"Larix là Giao thức tài chính dựa trên Metaverse đầu tiên trên Solana, áp dụng mô hình lãi suất động và tạo ra các nhóm quản lý vô cùng hiệu quả những rủi ro về vốn, chẳng hạn như có nhiều lựa chọn các loại tài sản thế chấp, token tiền điện tử, stablecoin, tài sản tổng hợp, NFT và các nhiều loại tài sản khác có thể được sử dụng một cách an toàn.",
        auditReport:"Audit Report",
        whyLarix:"Why Larix",
        reason1:"Giao thức cho vay vốn đầu tiên có chức năng khai thác trực tiếp",
        reason2:"Giao thức cho vay vốn đầu tiên hỗ trợ cho vay NFTs ngang hàng (P2P)",
        reason3:"Giao thức cho vay vốn đầu tiên có mã nguồn mở trên Solana",
        roadmap:"Roadmap",
        roadmapStep1:"Giai đoạn 1: Tháng 6 – Tháng 9 2021",
        roadmapStep2:"Giai đoạn 2: Cuối năm 2021 to 2022",
        roadmapStep3:"Giai đoạn 3: Từ 2022 trở đi",
        roadmapStep1Context:"Larix bắt đầu từ việc đáp ứng các nhu cầu thiết yếu của DeFi trong việc cho vay tự động. Ở giai đoạn này, token tiền điện tử, stablecoin và tài sản tổng hợp được chấp nhận làm tài sản thế chấp. Quản lý rủi ro và bảo mật tài sản là nền tảng của Larix.",
        roadmapStep2Context:"Hợp tác với mạng PYTH để kết nối thị trường tài chính có độ trung thực cao (HiFi) tới thế giới tài chính phi tập trung (Defi), cho phép sử dụng vốn cao hơn với nhiều loại tài sản tài chính thông dụng.",
        roadmapStep3Context:"Giao thức mở rộng cơ sở tài sản thế chấp để chấp nhận Non-Fungible Token (NFTs) thông qua cho vay ngang hàng (P2P) trên tất cả các loại tài sản. Larix sẽ làm việc với nhiều đối tác để cung cấp đảm bảo sự an toàn, tùy biến và tính thanh khoản gần như tức thì cho nền kinh tế thực.",
        seedRoundInvestor:"Nhà đầu tư ",
        partnership:"Đối tác",
        audit:"Audit",
    },
    liquidation: {
        liquidation : 'Thanh lý',
        liquidateTips : 'Mẹo thanh lý',
        account: 'Tài khoản',
        amountTip: 'Số tiền bạn muốn thanh toán',
        assetToRepay :'Tài sản để thanh toán',
        assetsToRepay :'Những tài sản để thanh toán',
        maxRepayAmount: 'Mức thanh toán cao nhất',
        assetToSeize : 'Tài sản được nhận',
        assetsToSeize : 'Những tài sản được nhận',
        maxSeizeAmount : 'Thu nhập cao nhất',
        debtRatio : 'Tỷ lệ Nợ',
        action : 'Hành động',
        liquidate : 'Thanh lý',
    },
    noticeDialog: {
        notice : 'Lưu ý',
        text : 'Thời gian bắt đầu khai thác',
        confirm: 'Xác nhận'
    },
    pendingDialog: {
        transactionPending: "Đang chờ",
        viewOnEtherscan: "Xem trên Heco",
        confirm: "Xác nhận Giao dịch...",
        broadcast: "Gửi Giao dịch...",
        waitingEvm: "Đang chờ kết quả EVM...",
        errorTips:"Giao dịch Thất bại",
        checkTips:"Giao dịch Thành công"
    },
    handleLpDialog:{
        unsettledAssets:'Chưa quyết toán tài sản',
        withdraw:'Rút',
        keepMining:'khai thác',
        tooltip:'Hãy chọn một lệnh bạn muốn thực hiện'
    },
    openObligationDialog:{
        openChoose:'Mở hoặc chọn tài khoản phụ',
        usable:'tài khoản phụ có thể sử dụng:',
        unavailable:'không tài khoản phụ Có sẵn',
        rulesLine1:'* lp Thế chấp qui định:',
        rulesLine2:'Một tài khoản phụ chỉ có thể thế chấp một tài sản LP',
        action:'Mở tài khoản mới và tài sản thế chấp',
    },
    borrowFeeTipDialog:{
        tip:'Tip',
        noBorrowFee:'Không có phí vay trên Larix',
        gotIt:'Hiểu rồi',
    },
    larixStakingDialog:{
        expireDate:'Expire date',
        stakedLP:'LP cổ phiếu',
        assets:'Tài sản',
        amount:'số lượng',
        unlockingTime:'thời gian mở khóa',
        stakeTime:'Locked Date',
        actions:'hành động',
        unlocking:'Unlocking',
        oneClickClaim:'Claim LARIX rewards from Raydium',
        claim:'Claim',
        raydiumReward:'Raydium Phần thưởng',
    },
    tip:{
        borrowLimitTip:'Hạn mức vay là số tài sản tối đa bạn có thể vay. Điều này được đánh dấu bằng một thanh trái cam. Giá trị tài sản cung ứng càng cao thì hạn mức vay càng cao',
        borrowBalanceTip:'Số dư đi vay là tổng của tất cả các tài sản đi vay',
        supplyBalanceTip:'Cán cân cung ứng là tổng của tất cả các tài sản được cung ứng. Tiền gửi tăng có thể làm tăng giới hạn vay của bạn',
        netAPRTip:'APR ròng = Tổng sản lượng hàng năm  / Giá trị ròng ( Tổng sản lượng hàng năm = tổng sản lượng cung ứng - tổng chi phí vay )',
        netValueTip:'Giá trị ròng = Cán cân cung ứng-Cân bằng vay',
        borrowRatioTip:'Tỷ lệ đi vay = Tổng số tiền vay / Số dư cung. Tỷ lệ đi vay phản ánh tỷ lệ sử dụng tài sản của bạn và giới hạn trên là giới hạn đi vay',
        liquidationTip:'Tổng số tiền đã vay khi tài khoản kích hoạt thanh lý. Ngưỡng này được đánh dấu bằng thanh màu đỏ. Khi tổng số tiền đã vay => ngưỡng thanh lý, tài khoản sẽ chuyển sang trạng thái có thể thanh lý. Tăng tiền gửi hoặc giảm các khoản vay có thể giải phóng tài khoản của bạn khỏi tình trạng thanh lý',
        supplyAPRTip:'Tỷ lệ phần trăm hàng năm (APR) kiếm được khi cung cấp tài sản. APR là động và dao động khi tổng nguồn cung trong nhóm tăng / giảm. APR cung cấp = lãi suất cung ứng (lợi tức của tài sản được cung cấp) + lợi suất khai thác cung cấp (mã thông báo LARIX)',
        borrowAPRTip:'Tỷ lệ phần trăm hàng năm (APR) được trả cho tài sản đi vay. APR rất động và dao động khi tổng số tiền đi vay trong nhóm tăng / giảm. Vay APR = lãi vay (chi phí để vay mã thông báo cụ thể) - lãi khai thác (mã thông báo LARIX)',
        walletBalanceTip:'Số dư trên Wallet là số dư của các tài sản khác nhau trong ví của bạn. Số dư trên Wallet có thể được sử dụng để cung cấp hoặc hoàn trả các tài sản đã vay và các khoản lãi tương ứng',
        liquidityTip:'Tính thanh khoản là số dư hiện tại của một tài sản có thể rút / vay. Thanh khoản dồi dào cũng có nghĩa là bạn có thể rút tiền gửi của mình bất cứ lúc nào',
        borrowFeeTip:'Larix có chính sách "không tính phí vay". Phí vay là một khoản phụ phí khi vay, khác với lãi đi vay. Phí vay = Số tiền vay * Tỷ lệ phí vay. Số tiền vay lớn hơn sẽ dẫn đến tỷ lệ phí vay cao hơn, dẫn đến phí vay lớn hơn. Phí vay được tính mỗi khi thực hiện giao dịch',
        collateralTip:'Sau khi gửi tiền bạn cần bật nút tài sản thế chấp để vay. Giá trị đặt cược của tài sản càng cao thì số tiền bạn có thể vay (tức là hạn mức vay) càng cao',
        availableTip:'Có sẵn là tài sản có thể cho vay tối đa hiện tại của bạn',
        myRewardTip:'Cung cấp / mượn mã thông báo đơn lẻ hoặc LP cổ phần tại Larix có thể kiếm được lợi suất khai thác (mã thông báo LARIX), đây là lợi suất khai thác cung cấp / mượn của bạn',
        myStakeTip:'Số lượng LARIX / USDC LP đã đặt cọc tại Raydium khi bạn chọn phần thưởng tăng cường x5 / x10',
        lockedDateTip:'Ngày khóa là ngày bạn chọn phần thưởng tăng cường x5 / x10 và đặt cược LARIX / USDC LP. Bạn không thể rút LARIX / USDC LP đã đặt cọc trong thời gian khóa (90 ngày hoặc 180 ngày)',
        unlockingDateTip:'Thời gian mở khóa là ngày bạn có thể nhận phần thưởng tăng gấp 5 lần / 10x LARIX và mở khóa LP sau 90 ngày / 180 ngày kể từ ngày đặt cược',
        stakeAmountTip:'Số lượng là số lượng LARIX / USDC LP được đặt cọc sau khi chọn phần thưởng tăng cường x5 / x10',
        raydiumRewardTip:'Sau khi chọn phần thưởng tăng cường x5 / x10 và thêm thanh khoản LARIX / USDC, bạn sẽ nhận được phần thưởng LARIX để khai thác thanh khoản, bạn có thể yêu cầu tại Larix bất kỳ lúc nào mà không cần thời gian khóa, chỉ cần nhấp vào nút "Yêu cầu" để thu hoạch tất cả. Phần RAY của phần thưởng sẽ được gửi vào ví của bạn sau khi bạn xóa thanh khoản khỏi Raydium',
        dailyTip:'Khai thác hàng ngày là số lượng mã thông báo LARIX hàng ngày kiếm được bằng cách cung cấp và vay mượn tài sản',
        collateralFactorTip:'Tỷ lệ tài sản có thể cho vay tối đa của một đơn vị tài sản thế chấp. Ví dụ: nếu bạn cung cấp USDC trị giá 100 đô la và có thể vay BTC trị giá tới 85 đô la, thì hệ số tài sản thế chấp của USDC là 85%',
        larixRewards:'LARIX Phần thưởng',
        dialogAPR1X:'Ban đầu 1X APR',
        dialogAPR5X:'Tăng cường 5X APR',
        APRTip:'Optional boosted APR if LARIX rewards are staked for 10x',
        baseRewardTip:'Receive local currency APR and LARIX APR',
        boostedAPRTip:'Optional boosted APR if LARIX rewards are staked for 5x',
        maxAPRTip:'(10x boosted staking)',
        baseAPRTip:'(Supply APR + LARIX rewards)',
        baseAPRTip2:'(Borrow APR - LARIX rewards)',
        interest:'interest',
        doubleRewardTip:'(Phần thưởng {x} sẽ được phân phối trực tiếp vào ví của bạn sau mỗi 24 giờ)',
        claimStakeRewardTip:'Click any \'Claim\' button to claim all LP rewards (5x and 10x included).  If there\'s still remaining unclaimed rewards, keep clicking \'Claim\' until all rewards are claimed.',
        liquidateTip:'Thanh lý xảy ra khi tỷ lệ nợ vượt quá 100%',
    },
    positions:{
        mySupply:'Nguồn cung cấp của tôi',
        myBorrow:'Khoản vay của tôi',
        myStake:'Cổ phần của tôi',
        myReward:'Phần thưởng của tôi',
        liquidationThreshol:'Ngưỡng thanh lý',
        claim:'Yêu cầu ',
        noSupplyYet:'Chưa có tiền đặt cọc',
        noBorrowYet:'Không vay nợ',
        noStakeYet:'Chưa có cổ phần',
        supplyNow:'Gửi tiền ngay bây giờ',
        borrowNow:'Vay ngay',
        stakeNow:'Đặt cọc ngay bây giờ',
    },
    launchpad:{
        whatLaunchpad:'Larix Lending Launchpad là gì?',
        details1:'Larix Lending Launchpad cung cấp một quỹ tài trợ riêng cho các mã thông báo SPL gốc',
        details2:'Larix đã tung ra một nhóm quỹ riêng biệt dựa trên nhóm cho vay thế chấp chéo hiện có, để hỗ trợ nhiều mã thông báo hơn để thực hiện chức năng cho vay',
        details3:'Nếu bạn muốn liệt kê bất kỳ tài sản mới nào trên Lending Launchpad, vui lòng điền vào biểu mẫu đăng ký',
        apply:'Áp dụng'
    }
}
